import React, { useRef, useState, useEffect } from 'react';
import { number } from 'prop-types';
import clsx from 'clsx';
import css from './SectionHero.module.css';

import {
  TourlyResponsiveImage,
  PreloadHighPriorityImage,
  HERO_SIZES,
  processVariantsForImage,
  getTourlyImageServer,
} from '../../../../util/responsiveImagesHelper';

import breakpoints from '../../../../styles/globals.module.scss';

const DELAY = 5000;

const SectionHeroImages = (props) => {
  const { heroWidth, bnbPage } = props;

  const aspectRatio = heroWidth > breakpoints.viewportMediumPixels ? 500 / 2500 : 313 / 430;
  const cropRadius = heroWidth > breakpoints.viewportMediumPixels ? '8132,1624' : '8600,6260';
  let heroHeight = Math.floor(heroWidth * aspectRatio);
  if (heroWidth <= breakpoints.viewportMediumPixels)
    heroHeight = 313;
  else 
    heroHeight = Math.min(500,Math.max(313,heroHeight)); // Ensuring it stays within 313 and 500 px

  const images = [
    {
      name: 'porto-ponte-dom-luis.webp',
      priority: 'high',
      cropCenter: 'center,500',
      params: 'fit=crop&crop=edges&con=-30',
    },
    {
      name: 'porto-cais-da-ribeira.webp',
      priority: 'high',
      cropCenter: 'center,500',
      params: 'fit=crop&crop=edges&con=-30',
    },
    {
      name: 'sintra-palacio.jpg',
      priority: 'high',
      cropCenter: '500,120',
      params: 'fit=crop&con=-30',
    },
    {
      name: 'madeira-ilheus.webp',
      priority: 'high',
      cropCenter: 'center,1200',
      params: 'fit=crop&crop=edges&con=-30',
    },
    {
      name: 'ponta-sao-lourenco.jpg',
      priority: 'high',
      cropCenter: 'center,850',
      params: 'fit=crop&con=-30',
    },
    {
      name: 'hero-bnbs.jpg',
      priority: 'high',
    },
  ];

  const LandingImages = images.slice(0, -1);

  const responsiveHeroImage = (image) => {
    const processedVariants =
      heroWidth > 0
        ? processVariantsForImage(
            false, // do not proxy image
            heroWidth,
            heroHeight,
            getTourlyImageServer().toString(),
            image.name,
            ['x1']
          )
        : {};

    const allParams = image.params + '&blend-alpha=100&blend-w=0.05' +
      '&h=' + heroHeight + '&rect=' + image.cropCenter; //+ ',' + cropRadius;
    return (
      <>
        <PreloadHighPriorityImage
          alt="Tourly hero image"
          image={processedVariants}
          variants={['x1']}
          sizes={HERO_SIZES}
          fetchpriority={image.priority}
          loading="eager"
          additionalParams={allParams}
        />
        <TourlyResponsiveImage
          alt="Tourly hero image"
          image={processedVariants}
          variants={['x1']}
          sizes={HERO_SIZES}
          fetchpriority={image.priority}
          loading="eager"
          additionalParams={allParams}
        />
      </>
    );
  };


  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);
  const revelRef = useRef([]);

  let slidesState = [];
  // function that interates the landing images array 
  // and creates an active object for each image
  const slideStateMap = LandingImages.map((field, index) => {
    if(index === 0){
      return  slidesState.push({
        ...field,
        active: true
      })
    } else {
      return slidesState.push({
        ...field,
        active: false
      })
    }
  });

  const [slideState, setSlideState] = useState(slidesState);

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  const updateImageState = (slideIndex) => {
    const update = (arr, id, updatedData) => {
      return arr.map((item, index) => (index === id ? { ...item, ...updatedData } : {'active': false}))
    }
 
    setSlideState(update(slideState, slideIndex, {'active': true}));
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = !!bnbPage ? null: ( setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === LandingImages.length - 1 ? 0 : prevIndex + 1
        ),
      DELAY
    ));

    return () => {
      resetTimeout();
    };
  }, [index]);

  useEffect(() => {
    !!bnbPage ? bnbLanding : updateImageState(index)     
  }, [index]);


  const activeSlide = clsx(css.slide, css.active)
  
  const landing = LandingImages.map((image, index) => (
    <div
      className={slideState[index].active ? activeSlide : css.slide}
      key={index}
      ref={(el) => (revelRef.current[index] = el)}
    >
    {responsiveHeroImage(images[index])}
    </div>
  ))

  const bnbLanding = (
    <div
      className={activeSlide}
    >
      {responsiveHeroImage(images[images.length-1])}
    </div>
  );

  return (
    <>
      {heroWidth > 0 ? (
        <>
          {!!bnbPage ? bnbLanding : landing }
        </>
      ) : null}
    </>
  );
};

SectionHeroImages.defaultProps = {
  heroWidth: 0,
};

SectionHeroImages.propTypes = {
  heroWidth: number.isRequired,
};

export default React.memo(SectionHeroImages,  (prevProps, nextProps ) => {
  if(prevProps.bnbPage !== nextProps.bnbPage) {
    return true
  }
  return false
});
